/* eslint-disable func-style */
const NoneTaxSettle = () => import('../pages/NoneTaxSettle/NoneTaxSettle');
const GenerateSettle = () => import('../pages/NoneTaxSettle/childPage/GenerateSettle');
const SettleManage = () => import('../pages/NoneTaxSettle/childPage/SettleManage');
const ArchiveRecord = () => import('../pages/NoneTaxSettle/ArchiveRecord');

export default [
	{
		path: '/NoneTaxSettle',
		name: 'NoneTaxSettle',
		component: NoneTaxSettle,
		children: [
			{ path: 'GenerateSettle', name: 'GenerateSettle', component: GenerateSettle, meta: { parent: '/NoneTaxSettle' } },
			{ path: 'SettleManage', name: 'SettleManage', component: SettleManage, meta: { parent: '/NoneTaxSettle' } },
		],
	},
	{
		path: '/ArchiveRecord',
		name: 'ArchiveRecord',
		component: ArchiveRecord,
	},
];
